/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRecentlySoldItems_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "SbSharedRecentlySoldItems_user";
};
export type SbSharedRecentlySoldItems_user$data = SbSharedRecentlySoldItems_user;
export type SbSharedRecentlySoldItems_user$key = {
    readonly " $data"?: SbSharedRecentlySoldItems_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRecentlySoldItems_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRecentlySoldItems_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '2056dc2a11be6a6f0f9a200f3e6c3bbf';
export default node;
